import React from 'react'

import { Localized } from '../../localization/react'

interface Props {
  venueName: string
  isOrderConfirmed: boolean
  hasBooking: boolean
  wasSomethingPayed: boolean
  isBookingRequest: boolean
}

const ConfirmationHeading: React.FC<React.PropsWithChildren<Props>> = ({
  venueName,
  isOrderConfirmed,
  hasBooking,
  wasSomethingPayed,
  isBookingRequest,
}) => {
  if (isBookingRequest) {
    return <Localized id="private-session-booking-request-confirmation-heading" />
  }
  if (!hasBooking && !wasSomethingPayed) {
    return <Localized id="free-product-confirmation-heading" />
  }

  if (!hasBooking) {
    return <Localized id="booking-payment-confirmation-heading" />
  }

  if (isOrderConfirmed) {
    return <Localized id="booking-confirmation-heading" />
  }

  return <Localized id="booking-confirmation-heading-not-confirmed" params={{ venue: venueName }} />
}

export default ConfirmationHeading
